export default (function () {
    var vars = {};
    vars.active = 'display:block';
    return vars;
});
